import { connect } from 'react-redux';
import Sidebar from '../../../components/layout/Sidebar';
import { viewsList } from 'core/selectors';

export default connect(
  state => ({
    views: viewsList(state),
  }),
  {},
)(Sidebar);
